export default class {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "typologySubnav";
		this.init();
	}

	init() {
		this.bindEvents(true);
	}

	bindEvents(bindDirection) {
        const anchors = document.querySelectorAll(".subnav-target");

        const sectionValues = [];
        const indexices = [];
        const yOffsets = [];
        let pageHeight = document.body.scrollHeight;
        let scrollOffset = window.innerHeight * 0.3;
        let sectionEnd = null;

        updateSectionValues();

        function updateSectionValues() {
            pageHeight = document.body.scrollHeight;
            
            anchors.forEach((el, i) => {
                indexices.push(el.dataset.sectionIndex);
                yOffsets.push(el.offsetTop);
            });

            indexices.forEach((el, i) => {
                sectionValues[i] = [];
                if(yOffsets[i+1]){
                    sectionEnd = yOffsets[i+1];
                } else {
                    sectionEnd = pageHeight;
                }
                if(i === 0){
                    sectionValues[i].push({"sectionIndex": el, "sectionStart": 0, "sectionEnd":sectionEnd});
                } else {
                    sectionValues[i].push({"sectionIndex": el, "sectionStart": yOffsets[i], "sectionEnd":sectionEnd});
                }
            });
        }

        let currentSection = null;

        function activateNav(active){
            currentSection = Number(active);
            document.querySelectorAll(".active-section").forEach((el) => el.classList.remove("active-section"));
            document.querySelector('[data-nav-index="' + currentSection + '"]').classList.add("active-section");
        }

        function sectionScroll(scrollPos){
            scrollPos = scrollPos + scrollOffset;
            sectionValues.forEach((el) => {
                if((scrollPos > el[0]['sectionStart'] && scrollPos <= el[0]['sectionEnd'])){
                    if(currentSection !== Number(el[0]['sectionIndex'])){
                        activateNav(el[0]['sectionIndex']);
                    }
                }
            });
        }

        let lastKnownScrollPosition = window.scrollY;
        let ticking = false;
        sectionScroll(lastKnownScrollPosition);

		let scrollPosOld = 0;
		let scrollPosNew = 0;
		let scrollDelta = 0;
		let scrollThreshold = 20;
		let scrollDown = false;
		window.addEventListener("scroll", (e) => {
			scrollPosNew = window.pageYOffset;
			let distanceTraveled = scrollDelta - scrollPosNew;
			if (window.pageYOffset > window.outerHeight) {
				if (distanceTraveled <= -1 * scrollThreshold) {
					scrollDelta = scrollPosNew;
					scrollDown = true;
					$(".typology-subnav").removeClass("scrollup");
				} else if (distanceTraveled >= scrollThreshold) {
					scrollDelta = scrollPosNew;
					scrollDown = false;
					$(".typology-subnav").addClass("scrollup");
				}
			} else {
				scrollDelta = scrollPosNew;
				scrollDown = false;
				$(".typology-subnav").removeClass("scrollup");
			}
			scrollPosOld = scrollPosNew;

            lastKnownScrollPosition = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    sectionScroll(lastKnownScrollPosition);
                    ticking = false;
                });
    
                ticking = true;
            }
		});

        window.addEventListener("resize", () => {
            updateSectionValues();
            lastKnownScrollPosition = window.scrollY;
            sectionScroll(lastKnownScrollPosition);
        });
        
	}

	destroy() {
		this.bindEvents(false);
	}
}